export const teal = {
  100: 'var(--bfc-v2-color-teal-100, #e7f9ff)',
  200: 'var(--bfc-v2-color-teal-200, #c6edfb)',
  300: 'var(--bfc-v2-color-teal-300, #9dd9ee)',
  400: 'var(--bfc-v2-color-teal-400, #6cc3e0)',
  500: 'var(--bfc-v2-color-teal-500, #42b2d7)',
  600: 'var(--bfc-v2-color-teal-600, #2898bd)',
  700: 'var(--bfc-v2-color-teal-700, #227d9b)',
  800: 'var(--bfc-v2-color-teal-800, #206a83)',
  900: 'var(--bfc-v2-color-teal-900, #164555)',
  1000: 'var(--bfc-v2-color-teal-1000, #1e3137)',
  DEFAULT: 'var(--bfc-v2-color-teal-700, #227d9b)', // 700
};
